module.exports = __webpack_public_path__ + "media/images/footer-bg-202c84499a4edf7e4faa88a0be2c6bff.svg";